import { Clock, MapPin, Store, UtensilsCrossed } from "lucide-react";
import { HiOutlineDocumentText } from "react-icons/hi2";
import { formatValue } from "../../../../scripts/formatValue";
import styles from "./renderOrders.module.css";


export default function RenderOrders({item, index, companyData}){

  const isDelivery = item.type == 'DELIVERY';
  const totalValue = isDelivery ? (item.total ?? item.price) : item.price;
  let price = formatValue(totalValue);

  const date = new Date(item.created_at).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  const status =
    item.status == 'FINISHED' ? { text: "Entregue", style: styles.finished }
    : item.status == "CANCELED" ? { text: "Cancelado", style: styles.canceled }
    : item.status == "SENDING" ? { text: "Em entrega", style: styles.sending }
    : item.confirmation == false ? { text: "A confirmar", style: styles.pending }
    : { text: "Em preparo", style: styles.preparing };

  const showDeliveryTotals = isDelivery && typeof item.subtotal !== 'undefined' && typeof item.delivery_tax !== 'undefined';



  return (
    <li key={index}>
      <article className={styles.orderCard}>
        <header className={styles.orderHeader}>
          <div>
            <p className={styles.orderCode}>Pedido {item.code}</p>
            <p className={styles.orderDate}>{date}</p>
          </div>

          <span className={`${styles.status} ${status.style}`}>{status.text}</span>
        </header>

        <div className={styles.infoList}>
          {companyData.type == 'delivery' ? (
            <>
              <p className={styles.infoRow}>
                <Store size={16} />
                <span><span className={styles.infoLabel}>Tipo:</span>Delivery</span>
              </p>
              <p className={styles.infoRow}>
                <MapPin size={16} />
                <span><span className={styles.infoLabel}>Endereço:</span>{item.delivery_address?.formattedAddress}</span>
              </p>
            </>

          ) : (
            <p className={styles.infoRow}>
              <UtensilsCrossed size={16} />
              <span>
                <span className={styles.infoLabel}>{item.location == 0 ? 'Local:' : 'Mesa:'}</span>
                {item.location == 0 ? 'Balcão' : item.location}
              </span>
            </p>
          )}

          {isDelivery && item.estimated_delivery_time && (
            <p className={styles.infoRow}>
              <Clock size={16} />
              <span>
                <span className={styles.infoLabel}>Tempo de entrega:</span>
                {item.estimated_delivery_time.min} - {item.estimated_delivery_time.max} min
              </span>
            </p>
          )}
        </div>

        <div className={styles.productsArea}>
          <p className={styles.productsTitle}>Produtos</p>

          {item.products && item.products.map((prod, prodIndex) => (
            <div key={prodIndex} className={styles.productArea}>
              <div className={styles.productRow}>
                <p className={styles.productName}>
                  <span className={styles.qtyBadge}>{prod.amount}x</span>
                  {prod.name}
                </p>
                <p className={styles.productPrice}>{formatValue(prod.price)}</p>
              </div>

              {prod.complements && prod.complements.length > 0 && (
                <div className={styles.complementsArea}>
                  {prod.complements.map((comp, compIndex) => (
                    <p key={compIndex} className={styles.complementText}>{comp.quantity}x {comp.complement}</p>
                  ))}
                </div>
              )}

              {prod.observation && (
                <div className={styles.observationArea}>
                  <p className={styles.labelObservation}>
                    <HiOutlineDocumentText size={12} />
                    Observações
                  </p>
                  <p className={styles.observationText}>{prod.observation}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <footer className={styles.orderFooter}>
          {showDeliveryTotals && (
            <>
              <div className={styles.footerRow}>
                <span>Subtotal</span>
                <span>{formatValue(item.subtotal)}</span>
              </div>
              <div className={styles.footerRow}>
                <span>Entrega</span>
                <span>{formatValue(item.delivery_tax)}</span>
              </div>
            </>
          )}

          <div className={`${styles.footerRow} ${styles.grand}`}>
            <span>Total</span>
            <span>{price}</span>
          </div>
        </footer>
      </article>
    </li>
  );
}
